<template>
	<div class="flow-dropdown-menu-wrapper">
		<div class="flow-dropdown-menu-trigger">
			<slot name="trigger" />
		</div>
		<div class="flow-dropdown-menu" :style="{ width: width + 'px' }" :open="open">
			<slot />
		</div>
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "DropdownMenu",
	props: {
		open: {
			type: Boolean,
			default: false
		},
		/**
		 * in px
		 */
		width: {
			type: Number,
			default: 100
		}
	}
});
</script>
<style lang="scss">
div.flow-dropdown-menu-wrapper {
	position: relative;

	> div.flow-dropdown-menu-trigger {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	> div.flow-dropdown-menu {
		&[open] {
			display: flex;
		}
		position: absolute;
		border: 1px solid var(--dashboard-border);
		border-radius: 4px;
		background-color: var(--dashboard-element-light);
		display: none;
		flex-direction: column;
		right: 0px;
		top: 40px;
		// left: -125px;
		z-index: 102;

		> * {
			padding: 10px;
			display: flex;
			align-items: center;
			background-color: var(--dashboard-element-light);
			cursor: pointer;
			> * {
				margin-right: 8px;
			}

			position: relative;

			&:hover:not([disable-hover]) {
				&:before {
					content: "";
					top: 0px;
					left: 0px;
					right: 0px;
					bottom: 0px;
					position: absolute;
					background-color: #000;
					opacity: 0.2;
				}
			}
		}
	}
}
</style>
